var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"data-background-color":"black"}},[_c('div',{staticClass:"sl-block",staticStyle:{"width":"700px","margin":"auto"},attrs:{"data-block-type":"text"}},[_c('div',{ref:"clock",staticClass:"clockCanvas",attrs:{"id":_vm.canvasId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }